import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotFound from '@rsos/components/capstone/ErrorBoundary/NotFound';
import { DiscrepancyReporting } from './discrepancy-reporting/DiscrepancyReporting';
import { MapLayers } from './map-layers/MapLayers';
import DataSources from './roles';

export const DatasourceManagementRouter = () => {
  return (
    <>
      <Routes>
        <Route path="" element={<Navigate to="roles" />} />
        <Route path="roles" element={<DataSources />} />
        <Route
          path="discrepancy-reporting"
          element={<DiscrepancyReporting />}
        />
        <Route path="map-layers" element={<MapLayers />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};
